// @ts-nocheck

import { createFileRoute } from "@tanstack/react-router";
import Chats from "../../components/Chat/Chats";
import { useEffect, useState } from "react";
import { useLiveQuery } from "dexie-react-hooks";
import { db } from "../../db/db";
import getAuth from "../../msalAuth";

export const Route = createFileRoute("/chats/")({
  component: RouteComponent,
});

function RouteComponent() {
  // const [userID, setUserID] = useState();
  // useEffect(() => {
  //   const auth = getAuth();
  //   if (auth) setUserID(auth);
  // }, []);
  // const [rooms, setRooms] = useState([]);
  // const [roomIds, setRoomIds] = useState([]);
  // const [allRooms, setAllRooms] = useState([]);
  // useEffect(() => {
  //   if (userID) {
  //     fetch("https://pulse-backend.scttrgd.dev/rooms")
  //       .then((response) => response.json())
  //       .then((response) => setAllRooms(response))
  //       .catch((err) => console.error(err));
  //   }
  // }, [userID]);

  // useEffect(() => {
  //   if (userID) {
  //     if (userID['tag'].includes("ALL")) {
  //       setRooms(allRooms)
  //     }
  //     else {
  //       setRooms(
  //       allRooms.filter((room) =>
  //         userID["tag"].replace(/\s/g, "").split(",").includes(room["tag"])
  //       )
  //     );
  //   }
  //   }
  // }, [allRooms, userID]);
  // useEffect(()=> {
  //   if (rooms) {
  //     setRoomIds(rooms.map((room) => room['id']))
  //   }
  // },[rooms])
  //   const roomNotifications = useLiveQuery(
  //     () => db.chat_notifications.where('roomId').anyOf(roomIds).toArray(),
  //     [roomIds]
  //   );
  // if (!rooms) {
  //   return null;
  // }
  return (
    <>
      <iframe
        src="https://ehchat.scttrgd.dev/?stream=feedback&topic=test"
        className="w-full h-[80vh] rounded-box border-2 border-accent"
        title="Chat"
      ></iframe>
      {/* <ul className="list rounded-box shadow-md my-5 w-full border border-accent">
        <li className="p-4 pb-2 text-lg opacity-60 tracking-wide">Chats</li>
        <Chats rooms={rooms} roomNotifications={roomNotifications} />
      </ul> */}
    </>
  );
}
